import {
  QuoteEmailResultsType,
  QuoteRecipientsType,
  QuoteSendStatusType
} from 'data/types';

export function resolveQuoteSendStatus(
  results: QuoteEmailResultsType,
  { email }: QuoteRecipientsType
): QuoteSendStatusType {
  const phoneOnly = email.trim().length === 0;
  return phoneOnly && results.smsSent === false ? 'unsent' : 'sent';
}
